import React from 'react'

import { Space } from 'antd'
import ProfileIcon from '../ProfileIcon'
import DropDownNotification from '../DropDownNotification'
import CourseNavigation from '../CourseNavigation'

import styled from 'styled-components'

const FlexedDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 15px 32px;
  background: #fff;
`

const AppHeader = ({ courseMatch, courseNavigation, name }) => {
  return (
    <FlexedDiv
      style={{
        position: 'fixed',
        width: 'calc(100% - 240px)',
        top: 0,
        left: 220,
        zIndex: 1000,
        border: '0.1px solid #eae3e3',
        borderRadius: '16px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)'
      }}
    >
      <Space>
        {courseNavigation ? (
          <CourseNavigation courseMatch={courseMatch} />
        ) : (
          <h2 style={{ fontSize: '24px', fontWeight: 600 }}>Hello {name}</h2>
        )}
      </Space>
      <Space style={{ gap: '20px' }}>
        <DropDownNotification />
        <ProfileIcon />
      </Space>
    </FlexedDiv>
  )
}

export default AppHeader
